import { useMediaProps } from "@zapier/responsive-utils";

export const embedQueries = {
  desktop: `(min-width: 885px)`,
  tablet: `(min-width: 660px) and (max-width: 885px)`,
};

const queries = {
  desktop: `(min-width: 1024px)`,
  tablet: `(min-width: 660px) and (max-width: 1023px)`,
};

export type SizeType = "small" | "medium" | "large";

export function useSize({ isEmbed = false } = {}): SizeType {
  const queryOptions = isEmbed ? embedQueries : queries;

  return useMediaProps({
    all: {
      size: "small",
    },
    [queryOptions.tablet]: { size: "medium" },
    [queryOptions.desktop]: { size: "large" },
  }).size;
}
